import React, { FC, useEffect } from "react";
import { useGetAccountsQuery } from "@store/accountApi";
import { setAccountId } from "@store/accountSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@store/store";
import Loader from "@components/Loader/Loader";

const AccountGuard: FC<{ children: React.ReactElement }> = ({ children }) => {
  const isPatient = useSelector(
    (state: RootState) => state.auth.user?.isPatient,
  );
  const { data, isFetching, isError } = useGetAccountsQuery(undefined, {
    skip: isPatient,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPatient) {
      return;
    }
    if (data?.data?.length) {
      dispatch(setAccountId(data.data[0].id));
    } else if (!isFetching && !isError) {
      navigate("/onboarding");
    }
  }, [data, dispatch, navigate, isFetching, isPatient, isError]);

  if (!isPatient && isFetching) {
    return <Loader />;
  }

  return children;
};

export default AccountGuard;
